export const WORKER_MISSING_PAY_FETCH_BEGIN = 'syftacp/WORKER_MISSING_PAY_FETCH_BEGIN' as const
export const WORKER_MISSING_PAY_FETCH_FAILED = 'syftacp/WORKER_MISSING_PAY_FETCH_FAILED' as const
export const WORKER_MISSING_PAY_FETCH_SUCCEEDED = 'syftacp/WORKER_MISSING_PAY_FETCH_SUCCEEDED' as const
export const WORKER_MISSING_PAY_DELETE_BEGIN = 'syftacp/WORKER_MISSING_PAY_DELETE_BEGIN' as const
export const WORKER_MISSING_PAY_DELETE_FAILED = 'syftacp/WORKER_MISSING_PAY_DELETE_FAILED' as const
export const WORKER_MISSING_PAY_DELETE_SUCCEEDED = 'syftacp/WORKER_MISSING_PAY_DELETE_SUCCEEDED' as const
